import { useLoadingStore } from "./loading";
import { useUserStore } from "./user";

export const userStore = useUserStore();
export const loadingStore = useLoadingStore();